<template>
    <div v-if="show">
        <!-- Top -->
        <div class="head border-b border-t py-[10px] px-[20px] bg-blue-700 border-gray-400">
            <div class="text-white xl:mx-auto font-bold">
                <div>第三人責任險</div>
            </div>
        </div>
        <!-- / Top -->
        <div class="pb-6">
            <!-- Head -->
            <div class="bg-blue-200 py-[10px] px-[20px]">
                <div class="flex text-black justify-between xl:mx-auto font-bold">
                    <div>險種名稱 / 保障內容</div>
                    <div>保額</div>
                </div>
            </div>
            <!-- /Head -->

            <!-- Body -->
            <div class="px-[20px] pt-8">
                <!-- 第三人責任險 -->
                <div class="xl:mx-auto">
                    <template v-if="insures['31']">
                        <FormInfoInsText 
                            text="第三人責任險"
                            @click="onClickShowInsInfo('2', false)"
                        />
                        <!-- 31 第三人傷害責任 -->
                        <div class="mt-6">
                            <div class="flex font-bold">
                                31 {{ $store.state.ins31.name }}
                            </div>

                            <!-- Properties -->
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每人傷害 </div>
                                    <div> {{ ins31InjuredCover }} </div>
                                </div>
                            </div>

                            <div class="mt-6 flex justify-end items-center">
                                {{ ins31InjuredCoverMultiple }}
                            </div>
                            <!-- / Properties -->
                            <div class="flex justify-between items-center mt-6">
                                <div> 每一事故傷害總額 </div>
                                <div> {{ ins31DamageCover }} </div>
                            </div>
                        </div>
                        <!-- / 31 第三人傷害責任 -->

                        <!-- 32 第三人財損責任 -->
                        <div class="mt-6">
                            <div class="font-bold">
                                32 {{ $store.state.ins32.name }}
                            </div>

                            <!-- Properties -->
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每事故財物損失 </div>
                                    <div> {{ ins32DamageCover }} </div>
                                </div>
                            </div>
                        <!-- / Properties -->
                        </div>
                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['31'].IndirectPrem && insures['32'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ group04IndirectPrem }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(group04Prem) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    <!-- / 32 第三人財損責任 -->
                    </template>
                    
                    <template v-if="insures['231']">
                        <FormInfoInsText 
                            text="第三人責任險"
                            @click="onClickShowInsInfo('8', false)"
                        />
                        <!-- 231 第三人傷害責任 -->
                        <div class="mt-6">
                            <div class="flex font-bold">
                                231 {{ $store.state.ins231.name }}
                            </div>

                            <!-- Properties -->
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每人傷害 </div>
                                    <div> {{ ins231InjuredCover }} </div>
                                </div>
                            </div>

                            <div class="mt-6 flex justify-end items-center">
                                {{ ins231InjuredCoverMultiple }}
                            </div>
                            <!-- / Properties -->
                            <div class="flex justify-between items-center mt-6">
                                <div> 每一事故傷害總額 </div>
                                <div> {{ ins231DamageCover }} </div>
                            </div>
                        </div>
                        <!-- / 231 第三人傷害責任 -->

                        <!-- 232 第三人財損責任 -->
                        <div class="mt-6">
                            <div class="font-bold">
                                232 {{ $store.state.ins232.name }}
                            </div>

                            <!-- Properties -->
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每事故財物損失 </div>
                                    <div> {{ ins232DamageCover }} </div>
                                </div>
                            </div>
                        <!-- / Properties -->
                        </div>
                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['231'].IndirectPrem && insures['232'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ group05IndirectPrem }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(group05Prem) }}
                                </span>
                            </div>
                        </div>
                    <!-- / Price -->
                    <!-- / 232 第三人財損責任 -->
                    </template>

                    <template v-if="insures['113']">
                        <FormInfoInsText 
                            text="第三人責任綜合保險"
                            @click="onClickShowInsInfo('1', false)"
                        />
                        <!-- 113 -->
                        <div class="mt-6">
                            <div class="flex font-bold">
                                113 {{ $store.state.ins113.name }}
                            </div>

                            <!-- Properties -->
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每人傷害 </div>
                                    <div> {{ ins113InjuredCover }} </div>
                                </div>
                            </div>

                            <div class="mt-6">
                                <div class="flex justify-end items-center">
                                    <div> {{ ins113InjuredCoverMultiple }} </div>
                                </div>
                            </div>
                            <!-- / Properties -->
                            <div class="mt-6 flex justify-between items-center">
                                <div> 每一事故傷害總額 </div>
                                <div> {{ ins113DamageCover }} </div>
                            </div>
                        </div>
                        <!-- / 113 -->

                        <!-- 114 -->
                        <div class="mt-6">
                            <div class="flex font-bold">
                                114 {{ $store.state.ins114.name }}
                            </div>

                            <!-- Properties -->
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每一事故財物損失 </div>
                                    <div> {{ ins114DamageCover }} </div>
                                </div>
                            </div>
                        </div>
                        <!-- / 114 -->

                        <!-- 115 -->
                        <div class="mt-6">
                            <div class="flex font-bold">
                                115 {{ $store.state.ins115.name }}
                            </div>

                            <!-- Properties -->
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每一人住院 </div>
                                    <div> {{ ins115InjuredCover }} </div>
                                </div>
                            </div>
                            <div class="mt-6">
                                <div class="flex justify-between items-center">
                                    <div> 每一人身故 </div>
                                    <div> {{ ins115DeathCover }} </div>
                                </div>
                            </div>
                        </div>
                        <!-- / 115 -->

                        <!-- Price -->
                        <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                            <div
                                v-if="insures['113'].IndirectPrem && insures['114'].IndirectPrem && insures['115'].IndirectPrem"
                                class="text-[14px] text-gray-600 text-left xl:mr-6"
                            >
                                定價＄
                                <span class="font-bold text-[20px]">
                                    {{ group07IndirectPrem }}
                                </span>
                            </div>
                            <div class="text-[14px] text-right text-pink-800">
                                {{ priceText }}＄
                                <span class="font-bold text-[20px]">
                                    {{ $monetary.convertToLocaleString(group07Prem) }}
                                </span>
                            </div>
                        </div>
                        <!-- / Price -->
                    </template>
                </div>
                <!-- / 第三人責任險 -->

                <div
                    v-if="showAdditional"
                    class="bg-blue-400 mt-2 mb-4 p-[20px] rounded-2xl xl:mx-auto"
                >
                    <div class="flex items-center justify-between xl:mx-auto">
                        <div class="my-1 text-[16px] text-blue-700 font-bold">
                            附加險
                        </div>
                    </div>
                
                    <!-- 超額責任險 301 國道倍增型 -->
                    <template v-if="insures['301']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <div class="xl:mx-auto xl:px-0">
                                <div class="font-bold">
                                    超額責任險
                                </div>

                                <div class="mt-6">
                                    <div class="flex justify-between">
                                        <FormInfoInsText 
                                            :text="`301 ${ $store.state.ins301.name }`"
                                            @click="onClickShowInsInfo('301')"
                                        />
                                        <div> {{ ins301InjuredCover }} </div>
                                    </div>
                                    <div class="flex justify-end mt-5">
                                        {{ ins301Deduct }}
                                    </div>
                                </div>

                                <!-- Price -->
                                <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                    <div
                                        v-if="insures['301'].IndirectPrem"
                                        class="text-[14px] text-gray-600 text-left xl:mr-6"
                                    >
                                        定價＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['301'].IndirectPrem) }}
                                        </span>
                                    </div>
                                    <div class="text-[14px] text-right text-pink-800">
                                        {{ priceText }}＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['301'].InsPremium) }}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Price -->
                            </div>
                        </div>
                    </template>
                    <!-- / 超額責任險 301 國道倍增型 -->

                    <!-- 超額責任險 30 保障型 -->
                    <template v-if="insures['30']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <div class="xl:mx-auto xl:px-0">
                                <div class="font-bold">
                                    超額責任險
                                </div>

                                <div class="mt-6">
                                    <div class="flex justify-between">
                                        <FormInfoInsText 
                                            :text="`30 ${ $store.state.ins30.name }`"
                                            @click="onClickShowInsInfo('30')"
                                        />
                                        <div> {{ ins30DamageCover }} </div>
                                    </div>
                                    <div class="flex justify-end mt-5">
                                        <div> {{ ins30Deduct }} </div>
                                    </div>
                                </div>

                                <!-- Price -->
                                <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                    <div
                                        v-if="insures['30'].IndirectPrem"
                                        class="text-[14px] text-gray-600 text-left xl:mr-6"
                                    >
                                        定價＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['30'].IndirectPrem) }}
                                        </span>
                                    </div>
                                    <div class="text-[14px] text-right text-pink-800">
                                        {{ priceText }}＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['30'].InsPremium) }}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Price -->
                            </div>
                        </div>
                    </template>
                    <!-- / 超額責任險 30 保障型 -->

                    <!-- 超額責任險 29 基本型 -->
                    <template v-if="insures['29']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <div class="xl:mx-auto xl:px-0">
                                <div class="font-bold">
                                    超額責任險
                                </div>

                                <div class="mt-6">
                                    <div class="flex justify-between">
                                        <FormInfoInsText 
                                            :text="`29 ${ $store.state.ins29.name }`"
                                            @click="onClickShowInsInfo('29')"
                                        />
                                        <div> {{ ins29DamageCover }} </div>
                                    </div>
                                </div>

                                <!-- Price -->
                                <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                    <div
                                        v-if="insures['29'].IndirectPrem"
                                        class="text-[14px] text-gray-600 text-left xl:mr-6"
                                    >
                                        定價＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['29'].IndirectPrem) }}
                                        </span>
                                    </div>
                                    <div class="text-[14px] text-right text-pink-800">
                                        {{ priceText }}＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['29'].InsPremium) }}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Price -->
                            </div>
                        </div>
                    </template>
                    <!-- / 超額責任險 29 基本型 -->

                    <!-- 178 充電期間附加條款-責任保險金 -->
                    <template v-if="insures['178']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`178 ${ $store.state.ins178.name }`"
                                @click="onClickShowInsInfo('178')"
                            />

                            <!-- 每一意外事故 -->
                            <div class="flex justify-between mt-6">
                                <div> 每一意外事故 </div>
                                <div> {{ ins178InjuredCover }} </div>
                            </div>

                            
                            <div class="flex justify-end mt-6">
                                <div> 2倍 </div>
                            </div>
                            <!-- / 每一意外事故 -->

                            <!-- 自負額 -->
                            <div class="flex justify-between mt-6">
                                <div> 自負額 </div>
                                <div> {{ ins178Deduct }} </div>
                            </div>
                            <!-- / 自負額 -->

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['178'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['178'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['178'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 178 充電期間附加條款-責任保險金 -->

                    <!-- 109 失能責任增額 -->
                    <template v-if="insures['109']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <div class="xl:mx-auto xl:px-0">
                                <FormInfoInsText 
                                    :text="`109 ${ $store.state.ins109.name }`"
                                    @click="onClickShowInsInfo('109')"
                                />

                                <!-- 每一人失能 -->
                                <div>
                                    <div class="flex justify-between mt-6">
                                        <div> 每一人失能 </div>
                                        <div> {{ ins109DeathCover }} </div>
                                    </div>

                                    <!-- Price -->
                                    <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                        <div
                                            v-if="insures['109'].IndirectPrem"
                                            class="text-[14px] text-gray-600 text-left xl:mr-6"
                                        >
                                            定價＄
                                            <span class="font-bold text-[20px]">
                                                {{ $monetary.convertToLocaleString(insures['109'].IndirectPrem) }}
                                            </span>
                                        </div>
                                        <div class="text-[14px] text-right text-pink-800">
                                            {{ priceText }}＄
                                            <span class="font-bold text-[20px]">
                                                {{ $monetary.convertToLocaleString(insures['109'].InsPremium) }}
                                            </span>
                                        </div>
                                    </div>
                                    <!-- / Price -->
                                </div>
                                <!-- / 每一人失能 -->
                            </div>
                        </div>
                    </template>
                    <!-- / 109 失能責任增額 -->

                    <!-- 55 乘客體傷責任 -->
                    <template v-if="insures['55']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <div class="xl:mx-auto xl:px-0">
                                <FormInfoInsText 
                                    :text="`55 ${ $store.state.ins55.name }`"
                                    @click="onClickShowInsInfo('55')"
                                />

                                <div>
                                    <!-- 每一人失能 -->
                                    <div class="flex justify-between mt-6">
                                        <div> 每一人傷害 </div>
                                        <div> {{ ins55DeathCover }} </div>
                                    </div>
                                    <!-- / 每一人失能 -->

                                    <!-- 每一意外事故-->
                                    <div class="flex justify-between mt-6">
                                        <div> 每一意外事故 </div>
                                        <div> {{ ins55DamageCover }} </div>
                                    </div>
                                    <!-- / 每一意外事故-->
                                </div>

                                <!-- Price -->
                                <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                    <div
                                        v-if="insures['55'].IndirectPrem"
                                        class="text-[14px] text-gray-600 text-left xl:mr-6"
                                    >
                                        定價＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['55'].IndirectPrem) }}
                                        </span>
                                    </div>
                                    <div class="text-[14px] text-right text-pink-800">
                                        {{ priceText }}＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['55'].InsPremium) }}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Price -->
                            </div>
                        </div>
                    </template>
                    <!-- / 55 乘客體傷責任 -->

                    <!-- 56 駕駛人傷害險 -->
                    <template v-if="insures['56']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <div class="flex items-center xl:mx-auto font-bold">
                                駕駛人傷害險
                            </div>

                            <div class="xl:mx-auto xl:px-0">
                                <div class="flex justify-between mt-6 flex-wrap md:flex-nowrap">
                                    <FormInfoInsText 
                                        :text="`56 ${ $store.state.ins56.name }`"
                                        @click="onClickShowInsInfo('56')"
                                    />
                                    <div class="mt-[10px] md:mt-0 py-[5px] bg-blue-700 rounded-full text-white text-center w-full md:w-[220px]">
                                        需簽回要保書
                                    </div>
                                </div>

                                <!--  失能或身故保險金 -->
                                <div class="flex justify-between mt-6">
                                    <div> 失能或身故保險金 </div>
                                    <div> {{ ins56DamageCover }} </div>
                                </div>
                                <!-- / 失能或身故保險金 -->

                                <!-- 住院日額型-->
                                <div
                                    v-if="insures['56']['InsScope'] === '2'"
                                    class="flex justify-between mt-6"
                                >
                                    <div> 住院日額型 </div>
                                    <div> {{ ins56RemedyDailyPay }} </div>
                                </div>
                                <!-- / 住院日額型-->

                                <!-- 實支實付-->
                                <div
                                    v-if="insures['56']['InsScope'] === '3'"
                                    class="flex justify-between mt-6"
                                >
                                    <div> 實支實付 </div>
                                    <div> {{ ins56MedicalReimbursement }} </div>
                                </div>
                                <!-- / 實支實付-->

                                <!-- Price -->
                                <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                    <div class="text-[14px] text-gray-600 text-left xl:mr-6">
                                        定價＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['56'].IndirectPrem) }}
                                        </span>
                                    </div>
                                    <div class="text-[14px] text-right text-pink-800">
                                        {{ priceText }}＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['56'].InsPremium) }}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Price -->
                            </div>
                        </div>
                    </template>
                    <!-- / 56 駕駛人傷害險 -->

                    <!-- 166 駕駛人傷害險 (限車主) -->
                    <template v-if="insures['166']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <div class="flex items-center xl:mx-auto">
                                駕駛人傷害險
                            </div>
                            <div class="xl:mx-auto xl:px-0">
                                <div class="flex justify-between mt-6">
                                    <FormInfoInsText 
                                        :text="`166 ${ $store.state.ins166.name }`"
                                        @click="onClickShowInsInfo('166')"
                                    />
                                </div>

                                <!--  失能或身故保險金 -->
                                <div class="flex justify-between mt-6">
                                    <div> 失能或身故保險金 </div>
                                    <div> {{ ins166DamageCover }} </div>
                                </div>
                                <!-- / 失能或身故保險金 -->

                                <!-- 實支實付-->
                                <div class="flex justify-between mt-6">
                                    <div> 實支實付 </div>
                                    <div> {{ ins166RemedyDailyPay }} </div>
                                </div>
                                <!-- / 實支實付-->

                                <!-- Price -->
                                <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                    <div class="text-[14px] text-pink-800 list-price xl:mr-6">
                                        網路獨家
                                    </div>
                                    <div class="text-[14px] text-right text-pink-800">
                                        {{ priceText }}＄
                                        <span class="font-bold text-[20px]">
                                            {{ $monetary.convertToLocaleString(insures['166'].InsPremium) }}
                                        </span>
                                    </div>
                                </div>
                                <!-- / Price -->
                            </div>
                        </div>
                    </template>
                    <!-- / 166 駕駛人傷害險 (限車主) -->

                    <!-- 34 慰問保險金 -->
                    <template v-if="insures['34']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`34 ${ $store.state.ins34.name }`"
                                @click="onClickShowInsInfo('34')"
                            />

                            <!-- 每一人住院 -->
                            <div class="flex justify-between mt-6">
                                <div> 每一人住院 </div>
                                <div> {{ ins34InjuredCover }} </div>
                            </div>
                            <!-- / 每一人住院 -->

                            <!-- 每一人身故-->
                            <div class="flex justify-between mt-6">
                                <div> 每一人身故 </div>
                                <div> {{ ins34DeathCover }} </div>
                            </div>
                            <!-- / 每一人身故-->

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['34'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['34'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['34'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 34 慰問保險金 -->

                    <!-- 27 律師費用補償 -->
                    <template v-if="insures['27']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`27 ${ $store.state.ins27.name }`"
                                @click="onClickShowInsInfo('27')"
                            />

                            <!-- 每一意外事故 -->
                            <div class="flex justify-between mt-6">
                                <div> 每一意外事故 </div>
                                <div> {{ ins27DamageCover }} </div>
                            </div>
                            <!-- / 每一意外事故 -->

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['27'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['27'].IndirectPrem) }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ $monetary.convertToLocaleString(insures['27'].InsPremium) }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 27 律師費用補償 -->

                    <!-- 164 車內寵物意外險 -->
                    <template v-if="insures['164']">
                        <hr class="my-8">
                        <div class="xl:mx-auto">
                            <FormInfoInsText 
                                :text="`164 ${ $store.state.ins164.name }`"
                                @click="onClickShowInsInfo('164')"
                            />

                            <!-- 意外費用 -->
                            <div class="flex justify-between mt-6">
                                <div> 意外費用 </div>
                                <div> {{ ins164DamageCover }} </div>
                            </div>
                            <!-- / 意外費用 -->

                            <!-- 意外責任-->
                            <div class="flex justify-between mt-6">
                                <div> 意外責任 </div>
                                <div> {{ ins165DamageCover }} </div>
                            </div>
                            <!-- / 意外責任-->

                            <!-- Price -->
                            <div class="border-t border-gray-400 pt-[20px] mt-5 flex items-center justify-between xl:justify-end">
                                <div
                                    v-if="insures['164'].IndirectPrem"
                                    class="text-[14px] text-gray-600 text-left xl:mr-6"
                                >
                                    定價＄
                                    <span class="font-bold text-[20px]">
                                        {{ ins164IndirectPrem }}
                                    </span>
                                </div>
                                <div class="text-[14px] text-right text-pink-800">
                                    {{ priceText }}＄
                                    <span class="font-bold text-[20px]">
                                        {{ ins164Prem }}
                                    </span>
                                </div>
                            </div>
                            <!-- / Price -->
                        </div>
                    </template>
                    <!-- / 164 車內寵物意外險 -->
                </div>
            </div>
            <!-- / Body -->
        </div>
    </div>
</template>

<script>
import FormInfoInsText from '@/components/forms/InfoInsText';
/**
  * 查看詳細內容-第三人責任險
 */
export default {
    name: 'PolicyViewLiabilityInsurance',
    components: {FormInfoInsText},
    props: {
        /**
         * 已投保項目
         */
        carInsures: {
            type: Array,
            default: () => {
                return [];
            }
        },
        /**
         * 是否已經試算
         */
        isCalculated: {
            type: Boolean,
            default: false
        }
    },
    emits: ['showInsInfo', 'showIsItem'],
    data() {
        /**
         * @param {Object} insures 有投保的險種
         * @param {Boolean} show 是否顯示此區塊
         * @param {Boolean} showAdditional 是否顯示附加險
         */
        return {
            insures: {
                '31': null,
                '32': null,
                '301': null,
                '30': null,
                '29': null,
                '109': null,
                '55': null,
                '56': null,
                '166': null,
                '34': null,
                '27': null,
                '164': null,
                '165': null,
                '231': null,
                '232': null,
                '178': null,
                '113': null,
                '114': null,
                '115': null,
            },
            show: false,
            showAdditional: false
        };
    },
    computed: {
        // 第三人責任險 每人傷害
        ins31InjuredCover() {
            if (this.insures['31']) {
                return this.$insurance.getCoverText(this.$store.getters['ins31/injuredCoverOptionsValid'], this.insures['31'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // ins31 的 api 沒有帶“倍數”數值，需要自行計算
        ins31InjuredCoverMultiple() {
            if (this.insures['31']) {
                let multiple = (this.insures['31'].DamageCover / this.insures['31'].InjuredCover);
                return this.$insurance.getCoverText(this.$store.getters['ins31/injuredCoverMultipleOptionsValid'], multiple.toString(), '倍');
            } else {
                return null;
            }
        },
        // ins31 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins31DamageCover() {
            if (this.insures['31']) {
                return this.$monetary.convertToChineseUnit(this.insures['31'].DamageCover);
            } else {
                return null;
            }
        },
        // 32 第三人財損責任-每事故財物損失
        ins32DamageCover() {
            if (this.insures['32']) {
                return this.$insurance.getCoverText(this.$store.getters['ins32/damageCoverdamageCoverOptionsValidOptions'], this.insures['32'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 第三人責任險 每人傷害
        ins113InjuredCover() {
            if (this.insures['113']) {
                return this.$insurance.getCoverText(this.$store.getters['ins113/injuredCoverOptionsValid'], this.insures['113'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // ins113 的 api 沒有帶“倍數”數值，需要自行計算
        ins113InjuredCoverMultiple() {
            if (this.insures['113'].InjuredCover) {
                let multiple = (this.insures['113'].DamageCover / this.insures['113'].InjuredCover);
                return this.$insurance.getCoverText(this.$store.getters['ins113/injuredCoverMultipleOptionsValid'], multiple.toString(), '倍');
            } else {
                return null;
            }
        },
        // ins113 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        // @return {number}
        ins113DamageCover() {
            return this.$monetary.convertToChineseUnit(this.insures['113'].DamageCover);
        },
        // 114
        ins114DamageCover() {
            if (this.insures['114'].DamageCover) {
                return this.$insurance.getCoverText(this.$store.getters['ins114/damageCoverOptionsValid'], this.insures['114'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 115
        ins115InjuredCover() {
            if (this.insures['115'].InjuredCover) {
                return this.$insurance.getCoverText(this.$store.getters['ins115/injuredCoverOptionsValid'], this.insures['115'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // ins115
        ins115DeathCover() {
            return this.insures['115'].DeathCover ? this.$monetary.convertToChineseUnit(this.insures['115'].DeathCover) : null;
        },
        // 113+114+115 網路優惠價
        group07Prem() {
            return this.insures['113'].InsPremium + this.insures['114'].InsPremium + this.insures['115'].InsPremium;
        },
        // 113+114+115 網路優惠價
        group07IndirectPrem() {
            return this.$monetary.convertToLocaleString(this.insures['113'].IndirectPrem + this.insures['114'].IndirectPrem + this.insures['115'].IndirectPrem);
        },
        // 301 超額責任險-國道倍增型
        ins301InjuredCover() {
            if (this.insures['301']) {
                return this.$insurance.getCoverText(this.$store.getters['ins301/injuredCoverOptionsValid'], this.insures['301'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // 301 超額責任險-國道倍增型
        ins301Deduct() {
            if (this.insures['301']) {
                let deduct = this.insures['301'].Deduct < 4 ? 1 : 155;
                let insure = _.find(this.$store.getters['ins301/deductOptionsValid'], {value: deduct.toString()});
                return insure ? insure.text : '無符合條件';
            } else {
                return null;
            }
        },
        // 30 超額責任險-保障型
        ins30Deduct() {
            if (this.insures['30']) {
                let deduct = this.insures['30'].Deduct < 4 ? 1 : 155;
                let insure = _.find(this.$store.getters['ins30/deductOptionsValid'], {value: deduct.toString()});
                return insure ? insure.text : '無符合條件';
            } else {
                return null;
            }
        },
        // 30 超額責任險-保障型
        ins30DamageCover() {
            if (this.insures['30']) {
                return this.$insurance.getCoverText(this.$store.getters['ins30/damageCoverOptionsValid'], this.insures['30'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 29 超額責任險-基本型
        ins29DamageCover() {
            if (this.insures['29']) {
                return this.$insurance.getCoverText(this.$store.getters['ins29/damageCoverOptionsValid'], this.insures['29'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 109 失能責任增額附加條款
        ins109DeathCover() {
            if (this.insures['109']) {
                return this.$insurance.getCoverText(this.$store.getters['ins109/deathCoverOptionsValid'], this.insures['109'].DeathCover.toString());
            } else {
                return null;
            }
        },
        // 55 乘客體傷責任險-每一人傷害
        ins55DeathCover() {
            if (this.insures['55']) {
                return this.$insurance.getCoverText(this.$store.getters['ins55/deathCoverOptionsValid'], this.insures['55'].DeathCover.toString());
            } else {
                return null;
            }
        },
        // ins55 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins55DamageCover() {
            if (this.insures['55']) {
                return this.$monetary.convertToChineseUnit(this.insures['55'].DamageCover);
            } else {
                return null;
            }
        },
        // 56 駕駛人傷害險-失能或身故保險金
        ins56DamageCover() {
            if (this.insures['56']) {
                return this.$insurance.getCoverText(this.$store.getters['ins56/damageCoverOptionsValid'], this.insures['56'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 56 駕駛人傷害險-失能或身故保險金 住院日額
        ins56RemedyDailyPay() {
            if (this.insures['56']) {
                let value = null;
                if (this.insures['56'].RemedyDailyPay) {
                    value = this.insures['56'].RemedyDailyPay.toString();
                }
                return value ? this.$insurance.getCoverText(this.$store.getters['ins56/remedyDailyPayOptionsValid'], value) : null;
            } else {
                return null;
            }
        },
        // 56 駕駛人傷害險-失能或身故保險金 實支實付
        ins56MedicalReimbursement() {
            if (this.insures['56']) {
                let value = null;
                if (this.insures['56'].RemedyDailyPay) {
                    value = this.insures['56'].RemedyDailyPay.toString();
                }
                return value ? this.$insurance.getCoverText(this.$store.getters['ins56/medicalReimbursementOptionsValid'], value) : null;
            } else {
                return null;
            }
        },
        // 34 慰問保險金附加條款-每一人住院
        ins34InjuredCover() {
            if (this.insures['34']) {
                return this.$insurance.getCoverText(this.$store.getters['ins34/injuredCoverOptionsValid'], this.insures['34'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // ins34 DeathCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins34DeathCover() {
            return this.insures['34'] ? this.$monetary.convertToChineseUnit(this.insures['34'].DeathCover) : null;
        },
        // 27 律師費用補償附加條款-每一意外事故
        ins27DamageCover() {
            if (this.insures['27']) {
                return this.$insurance.getCoverText(this.$store.getters['ins27/damageCoverOptionsValid'], this.insures['27'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 164 車內寵物意外費用保險-意外費用
        ins164DamageCover() {
            if (this.insures['164']) {
                return this.$insurance.getCoverText(this.$store.getters['ins164/damageCoverOptionsValid'], this.insures['164'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 165 車內寵物意外費用保險-意外費用
        ins165DamageCover() {
            if (this.insures['164']) {
                return this.$insurance.getCoverText(this.$store.getters['ins165/damageCoverOptionsValid'], this.insures['165'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 165 車內寵物意外費用保險-網路優惠價
        ins164IndirectPrem() {
            return this.$monetary.convertToLocaleString(this.insures['164'].IndirectPrem + this.insures['165'].IndirectPrem);
        },
        // 164 車內寵物意外費用保險-網路優惠價
        ins164Prem() {
            return this.$monetary.convertToLocaleString(this.insures['164'].InsPremium + this.insures['165'].InsPremium);
        },
        // 166 駕駛人傷害險（限車主）-失能或身故保險金
        ins166DamageCover() {
            if (this.insures['166']) {
                return this.$insurance.getCoverText(this.$store.getters['ins166/damageCoverOptionsValid'], this.insures['166'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 166 駕駛人傷害險（限車主）-失能或身故保險金 實支實付
        ins166RemedyDailyPay() {
            if (this.insures['166'] && this.insures['166'].RemedyDailyPay) {
                return this.$monetary.convertToChineseUnit(this.insures['166'].RemedyDailyPay.toString());
            } else {
                return null;
            }
        },
        // 31 第三人傷害責任+32 第三人財損責任網路優惠價
        group04Prem() {
            return this.insures['31'].InsPremium + this.insures['32'].InsPremium;
        },
        // 31 第三人傷害責任+32 第三人財損責任網路優惠價
        group04IndirectPrem() {
            return this.$monetary.convertToLocaleString(this.insures['31'].IndirectPrem + this.insures['32'].IndirectPrem);
        },
        // 依據是否試算過，顯示「網路優惠價」或「參考價」字樣
        priceText() {
            return this.isCalculated ? '網路優惠價' : '參考價';
        },
        // 電動車第三人責任險 每人傷害
        ins231InjuredCover() {
            if (this.insures['231']) {
                return this.$insurance.getCoverText(this.$store.getters['ins231/injuredCoverOptionsValid'], this.insures['231'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // ins231 的 api 沒有帶“倍數”數值，需要自行計算
        ins231InjuredCoverMultiple() {
            if (this.insures['231']) {
                let multiple = (this.insures['231'].DamageCover / this.insures['231'].InjuredCover);
                return this.$insurance.getCoverText(this.$store.getters['ins231/injuredCoverMultipleOptionsValid'], multiple.toString(), '倍');
            } else {
                return null;
            }
        },
        // ins231 damageCover 不含在 GetInsuresAndCovers 內，需自行轉換
        ins231DamageCover() {
            if (this.insures['231']) {
                return this.$monetary.convertToChineseUnit(this.insures['231'].DamageCover);
            } else {
                return null;
            }
        },
        // 232 第三人財損責任-每事故財物損失
        ins232DamageCover() {
            if (this.insures['232']) {
                return this.$insurance.getCoverText(this.$store.getters['ins232/damageCoverdamageCoverOptionsValidOptions'], this.insures['232'].DamageCover.toString());
            } else {
                return null;
            }
        },
        // 231 第三人傷害責任+232 第三人財損責任網路優惠價
        group05Prem() {
            return this.insures['231'].InsPremium + this.insures['232'].InsPremium;
        },
        // 231 第三人傷害責任+232 第三人財損責任網路優惠價
        group05IndirectPrem() {
            return this.$monetary.convertToLocaleString(this.insures['231'].IndirectPrem + this.insures['232'].IndirectPrem);
        },
        // 178 充電期間附加條款-責任保險金-事故限額
        ins178InjuredCover() {
            if (this.insures['34']) {
                return this.$insurance.getCoverText(this.$store.getters['ins34/injuredCoverOptionsValid'], this.insures['34'].InjuredCover.toString());
            } else {
                return null;
            }
        },
        // 178 充電期間附加條款-責任保險金-自負額
        ins178Deduct(){
            if (this.insures['178']) {
                return this.$insurance.getCoverText(this.$store.getters['ins178/deductOptionsValid'], this.insures['178'].Deduct.toString());
            } else {
                return null;
            }
        }
    },
    mounted() {
        // 顯示線上投保成功的內容
        this.setContent();
        if (this.insures['29'] || this.insures['30'] || this.insures['301'] || this.insures['56'] || this.insures['166'] || this.insures['27'] || this.insures['34'] || this.insures['55'] || this.insures['164'] || this.insures['165'] || this.insures['109'] || this.insures['178']) {
            this.showAdditional = true;
        }
    },
    methods: {
        /**
         * 顯示線上投保成功的內容
         * 
         * @public
         */
        setContent() {
            _.forIn(this.insures, (value, key) => {
                this.insures[key] = _.find(this.carInsures, {InsType: key});
                if (this.insures[key]) this.show = true;
            });
        },
        /**
         * 顯示險種介紹（有代碼的險種說明）
         * 
         * @param {String} insType 險種
         * @property {Boolean} isItem true = 險種 false = 類別
         * @public
         */
        onClickShowInsInfo(insType, isItem) {
            this.$emit('showInsInfo', insType);
            this.$emit('showIsItem', isItem);
        },
    }
};
</script>
